import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export function PrivateRoute({ children }) {
    const { isAuthenticated, loading, initializing } = useAuth();

    if (loading || initializing) {
        return <div>Loading...</div>;
    }

    return isAuthenticated ? children : <Navigate to="/login" replace />;
}

export function AdminRoute({ children }) {
    const { isAuthenticated, isAdmin, loading, initializing } = useAuth();

    if (loading || initializing) {
        return <div>Loading...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return isAdmin ? children : <Navigate to="/dashboard" replace />;
}

export function RegionalRoute({ children }) {
    const { isAuthenticated, isAdmin, user, loading, initializing } = useAuth();

    if (loading || initializing) {
        return <div>Loading...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    const roles = user?.roles || [];
    const hasRegionalRole = roles.includes('regional_leader') || roles.includes('regional_assistant');
    return (isAdmin || hasRegionalRole) ? children : <Navigate to="/dashboard" replace />;
}
